import stripHtml from '../../utils/stripHtml';
import _ from 'lodash';

export const TitleValue = ({ val = '', truncateConfig }) => {
  return _.truncate(stripHtml(val.trim()), truncateConfig);
};
